/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentFragmentDoc, AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../attachments/Attachments.generated.js';
import { ProjectOverviewBuildingBox_ProjectFragmentDoc } from './ProjectOverviewBuildingBox.generated.js';
import { CustomFieldsFragmentDoc } from '../../custom-fields/CustomFieldsBox.generated.js';
import { ProjectSourceEntity_ProjectSourceFragmentDoc } from '../components/ProjectSourceEntity.generated.js';
import { ProjectSourceCreatedBy_ProjectSourceFragmentDoc } from '../components/ProjectSourceCreatedBy.generated.js';
export type ProjectOverviewHeaderBox_ProjectFragment = { __typename: 'Project', id: string, viewerPermissions: Array<Types.PermissionName>, owningSystemOrganisationId: string, state: Types.ProjectStateMachineStatus, createdAt?: any | null, type?: Types.ProjectType | null, description: string, categories: Array<string>, earliestStart?: any | null, deadline?: any | null, number: string, title: string, urgent: boolean, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }>, source: { __typename: 'ProjectSource', id: string, source: Types.ProjectSourceType, importFileName?: string | null, manualPageName?: Types.ProjectSourcePageName | null, quoteProductsDistributionId?: string | null, requestId?: string | null, requestTitle?: string | null, flowTemplateId?: string | null, flowTemplateTitle?: string | null, flowTemplateVersionCounter?: number | null, flowCallId?: string | null, createdByCrmOrganisationId?: string | null, crmOrganisationTitle?: string | null, createdByUserId?: string | null, userFamilyname?: string | null, userFirstname?: string | null, crmOrganisationLogo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, userAvatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string } }>, crmOrganisation?: { __typename: 'CrmCompany', id: string, title: string } | null, building?: { __typename: 'Building', id: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null, buildingItem?: { __typename: 'Item', id: string, docId: string, title: string } | null, budget?: { __typename: 'Money', amount: number, currency: string } | null, customFields: Array<{ __typename: 'CustomFieldField', key: string, label: string, value: any, dataType: Types.CustomFieldDataType, group: string }> };

export type ProjectOverviewForm_ProjectFragment = { __typename: 'Project', id: string, title: string, description: string, categories: Array<string>, type?: Types.ProjectType | null, earliestStart?: any | null, deadline?: any | null, number: string, urgent: boolean, createdAt?: any | null, viewerPermissions: Array<Types.PermissionName>, budget?: { __typename: 'Money', amount: number, currency: string } | null };

export type ProjectOverviewData_ProjectFragment = { __typename: 'Project', id: string, createdAt?: any | null, type?: Types.ProjectType | null, description: string, categories: Array<string>, earliestStart?: any | null, deadline?: any | null, number: string, viewerPermissions: Array<Types.PermissionName>, budget?: { __typename: 'Money', amount: number } | null };

export type ProjectOverviewSource_ProjectSourceFragment = { __typename: 'ProjectSource', id: string, source: Types.ProjectSourceType, importFileName?: string | null, manualPageName?: Types.ProjectSourcePageName | null, quoteProductsDistributionId?: string | null, requestId?: string | null, requestTitle?: string | null, flowTemplateId?: string | null, flowTemplateTitle?: string | null, flowTemplateVersionCounter?: number | null, flowCallId?: string | null, createdByCrmOrganisationId?: string | null, crmOrganisationTitle?: string | null, createdByUserId?: string | null, userFamilyname?: string | null, userFirstname?: string | null, crmOrganisationLogo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, userAvatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null };

export const ProjectOverviewSource_ProjectSourceFragmentDoc = gql`
    fragment ProjectOverviewSource_ProjectSource on ProjectSource {
  id
  ...ProjectSourceEntity_ProjectSource
  ...ProjectSourceCreatedBy_ProjectSource
}
    ${ProjectSourceEntity_ProjectSourceFragmentDoc}
${ProjectSourceCreatedBy_ProjectSourceFragmentDoc}`;
export const ProjectOverviewData_ProjectFragmentDoc = gql`
    fragment ProjectOverviewData_Project on Project {
  id
  createdAt
  type
  description
  categories
  earliestStart
  deadline
  number
  budget {
    amount
  }
  viewerPermissions
}
    `;
export const ProjectOverviewForm_ProjectFragmentDoc = gql`
    fragment ProjectOverviewForm_Project on Project {
  id
  title
  description
  categories
  type
  earliestStart
  deadline
  budget {
    amount
    currency
  }
  number
  urgent
  createdAt
  viewerPermissions
}
    `;
export const ProjectOverviewHeaderBox_ProjectFragmentDoc = gql`
    fragment ProjectOverviewHeaderBox_Project on Project {
  id
  viewerPermissions
  owningSystemOrganisationId
  state
  attachments {
    ...Attachment
  }
  source {
    id
    ...ProjectOverviewSource_ProjectSource
  }
  ...ProjectOverviewBuildingBox_Project
  ...ProjectOverviewData_Project
  ...ProjectOverviewForm_Project
  ...CustomFields
  internalStakeholders {
    id
    user {
      id
    }
  }
}
    ${AttachmentFragmentDoc}
${ProjectOverviewSource_ProjectSourceFragmentDoc}
${ProjectOverviewBuildingBox_ProjectFragmentDoc}
${ProjectOverviewData_ProjectFragmentDoc}
${ProjectOverviewForm_ProjectFragmentDoc}
${CustomFieldsFragmentDoc}`;